import React, {useContext, useEffect} from 'react';
import {ScrubContainerContext} from "../../context/ScrubContainerContext";
import {SCRUB_CONTAINER_STRINGS} from "../../../../constants/Strings";
import {isNonNull} from "../../../utils/Util";
import {FormattedMessage} from "react-intl";
import {AppNavigationContext} from "../../../app-navigation/context/AppNavigationContext";
import {NotificationContext} from "../../../notification/context/NotificationContext";
import {VIEW} from "../../../workflow/Workflow";
import ScrubLocationConfirmationView from "./ScrubLocationConfirmationView";
import ScanLocationView from "./ScanLocationView";
import {PlayerContext} from "../../../player/context/PlayerContext";
import {ScanTypes} from "../../../player/PlayerConstant";
import {ApplicationActions} from "../../../player/action/ApplicationActions";

const ScrubLocationView = (props) => {
    const {notificationActions: {setNotification}} = useContext(NotificationContext);
    const {scrubContainerViewModel} = useContext(ScrubContainerContext);
    const {navActions: {setNavTitle}} = useContext(AppNavigationContext);
    const {statePlayer, dispatchPlayer} = useContext(PlayerContext);

    useEffect(() => {
        if (isNonNull(scrubContainerViewModel.notification)) {
            setNotification(scrubContainerViewModel.notification)
        }
        if(scrubContainerViewModel.responseCode !== "" && statePlayer.scanType === ScanTypes.SCRUB_LOCATION) {
            dispatchPlayer({type: ApplicationActions.SCRUB_CONTAINER_OR_LOCATION, data: {errorResponse: scrubContainerViewModel.responseCode, type: SCRUB_CONTAINER_STRINGS.scrub_location_title}});
        }
    }, [scrubContainerViewModel]);

    useEffect(() => {
        setNavTitle(<FormattedMessage id = {SCRUB_CONTAINER_STRINGS.scrub_location_title}/>);
    }, [])

    const renderView = () => {
        if (VIEW.SCRUB_LOCATION === scrubContainerViewModel.view || scrubContainerViewModel.view === '') {
            scrubContainerViewModel.view = VIEW.SCRUB_LOCATION;
            return <ScanLocationView history = {props.history}/>
        } else if (VIEW.SCRUB_LOCATION_CONFIRM === scrubContainerViewModel.view) {
            return <ScrubLocationConfirmationView history = {props.history}/>
        }
    }

    return (
        <div>
            {renderView()}

        </div>
    )
}

export default ScrubLocationView
